// extracted by mini-css-extract-plugin
export var linkText = "_nx-0";